module.exports = __webpack_public_path__ + "img/core-values-3.7f853bcc.svg";